var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 90,
    viewBox: "0 0 212 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo-SSC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 46.2705312 168.725013 46.2705312 168.725013 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 46.2705312 168.725013 46.2705312 168.725013 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SSC-redesign",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-links-on-top",
    transform: "translate(0.000000, -110.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-SSC",
    transform: "translate(0.000000, 110.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Footer",
    fill: "#009FE3",
    x: 0,
    y: 0,
    width: 211.5,
    height: 90
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(21.375000, 21.375000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3207581,19.2894086 C21.0457264,20.2935224 19.8812487,22.6709121 16.0857429,22.6709121 L0.529252028,22.6709121 L0.529252028,18.790689 L13.8810396,18.790689 C15.3626509,18.790689 15.8795119,17.6046469 15.8795119,16.0480737 C15.8795119,14.4656573 15.0408963,13.6732511 13.8810396,13.6732511 L5.25185598,13.6732511 C1.7810142,13.6732511 0.529252028,10.898118 0.323192191,10.3105737 C0.0586004057,9.19179196 -0.208900862,6.15805718 0.244636156,3.75893192 C0.3682036,3.06082721 1.53610421,5.13438134e-05 5.40845461,5.13438134e-05 L21.3322249,5.13438134e-05 L21.3322249,3.89516417 L7.7627396,3.89516417 C6.60305401,3.89516417 5.94088996,4.65659293 5.94088996,6.20392432 C5.94088996,7.69854272 6.57567064,8.52740302 7.7627396,8.52740302 L16.0071869,8.52740302 C19.6104957,8.52740302 21.0457264,10.9373105 21.3207581,11.7216728 C22.1020398,13.8902643 22.1020398,16.9604532 21.3207581,19.2894086",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "47.5411023 22.6709635 41.2971812 22.6709635 41.2971812 17.6437196 32.0712113 17.6437196 32.0712113 22.6709635 25.8267767 22.6709635 25.8267767 0.00677738337 32.0712113 0.00677738337 32.0712113 13.2620385 41.2971812 13.2620385 41.2971812 0.00677738337 47.5411023 0.00677738337"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "51.4499239 22.6696628 58.0583862 22.6696628 58.0583862 0.00547667343 51.4499239 0.00547667343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4764997,22.6709635 L85.2274442,22.6709635 L85.2274442,6.38710193 C85.2274442,5.25770918 84.1743826,3.94895538 82.6722338,3.94895538 L79.8431897,3.94895538 L79.8431897,22.6709635 L73.623229,22.6709635 L73.623229,3.94895538 L68.2114199,3.94895538 L68.2114199,22.6709635 L62.0030971,22.6709635 L62.0030971,0.00677738337 L86.0652041,0.00677738337 C89.6799797,0.00677738337 91.4764997,3.03127028 91.4764997,6.34260396 L91.4764997,22.6709635 Z",
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.911889,22.6709635 L111.673787,22.6709635 L111.673787,17.6437196 L101.661059,17.6437196 L101.661059,22.6709635 L95.4147414,22.6709635 L95.4147414,6.34260396 C95.4147414,3.03127028 97.3172008,0.00677738337 100.768019,0.00677738337 L112.574528,0.00677738337 C116.029796,0.00677738337 117.911889,3.03127028 117.911889,6.34260396 L117.911889,22.6709635 Z M109.133124,3.94895538 L104.174509,3.94895538 C102.684683,3.94895538 101.661059,5.25770918 101.661059,6.38710193 L101.661059,13.2620385 L111.673787,13.2620385 L111.673787,6.38710193 C111.673787,5.25770918 110.644001,3.94895538 109.133124,3.94895538 L109.133124,3.94895538 Z",
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.072856,22.6709635 L136.874973,22.6709635 L136.874973,6.38710193 C136.874973,5.25770918 135.83663,3.94895538 134.332599,3.94895538 L128.079949,3.94895538 L128.079949,22.6709635 L121.846639,22.6709635 L121.846639,0.00677738337 L137.718039,0.00677738337 C141.200176,0.00677738337 143.072856,3.03127028 143.072856,6.34260396 L143.072856,22.6709635 Z",
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.942944,3.94902383 L155.810623,3.94902383 C154.352288,3.94902383 153.250449,5.25640847 153.250449,6.38853955 L153.250449,16.2893382 C153.250449,17.4132543 154.352288,18.7367267 155.810623,18.7367267 L159.942944,18.7367267 C161.450399,18.7367267 162.447153,17.4132543 162.447153,16.2893382 L162.447153,6.38853955 C162.447153,5.25640847 161.450399,3.94902383 159.942944,3.94902383 L159.942944,3.94902383 Z M168.724961,16.324252 C168.724961,19.6559521 166.791011,22.6710319 163.309045,22.6710319 L152.419535,22.6710319 C148.916005,22.6710319 147.004303,19.6559521 147.004303,16.324252 L147.004303,6.34404158 C147.004303,3.03253676 148.916005,0.00547667343 152.419535,0.00547667343 L163.309045,0.00547667343 C166.791011,0.00547667343 168.724961,3.03253676 168.724961,6.34404158 L168.724961,16.324252 Z",
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3767558,45.904039 C10.0105033,46.2194612 9.68532581,46.2706339 8.17650228,46.2706339 L0.583779158,46.2706339 L0.583779158,44.9267951 L9.18575051,44.9267951 L9.18575051,43.6005844 L2.60244675,43.6005844 C1.90930527,43.6005844 1.45080502,43.5292165 1.20486815,43.3876788 C0.716588489,43.1004957 0.470651623,42.4590403 0.470651623,41.5021628 C0.470651623,40.9414883 0.564610801,40.5129386 0.726343813,40.2175406 C0.837931034,40.0330451 0.981693712,39.8928765 1.11450304,39.8215086 C1.56239224,39.5950824 2.26580248,39.475109 3.15302358,39.475109 L10.6437437,39.475109 L10.6437437,40.8997287 L2.11211334,40.8997287 L2.11211334,42.1747667 L8.87032835,42.1747667 C9.61361562,42.1747667 10.164877,42.3472819 10.470715,42.671946 C10.7228131,42.9389338 10.8256719,43.3661144 10.8256719,44.1908671 C10.8256719,45.2112399 10.7228131,45.5993991 10.3767558,45.904039",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "23.6065676 40.8483849 15.0976997 40.8483849 15.0976997 42.1436182 20.4188013 42.1436182 20.4188013 43.4888261 15.0976997 43.4888261 15.0976997 44.8458431 23.6065676 44.8458431 23.6065676 46.2706339 13.4659933 46.2706339 13.4659933 39.475109 23.6065676 39.475109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6953664,42.1760332 L34.8600532,42.1760332 L34.8600532,40.9319726 L27.6953664,40.9319726 L27.6953664,42.1760332 Z M36.3481681,43.3269904 C36.0940162,43.1221285 35.7770538,43.0197832 34.8602244,42.8782454 C36.1231111,42.6424062 36.4695106,42.3162018 36.4695106,41.3903017 C36.4695106,39.8713806 36.0017685,39.4750063 34.2276686,39.4750063 L25.9631973,39.4750063 L25.9631973,46.2705312 L27.6953664,46.2705312 L27.6953664,43.5494802 L34.8602244,43.5494802 L34.8602244,46.2705312 L36.571856,46.2705312 L36.571856,44.3242584 C36.571856,43.682803 36.5208545,43.458944 36.3481681,43.3269904 L36.3481681,43.3269904 Z",
    id: "Fill-13",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "45.1447325 46.2705654 42.9935979 46.2705654 38.3752219 39.50482 40.2206897 39.4750406 44.083627 45.0480692 47.5091151 39.4750406 49.3723821 39.4750406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "51.2791202 46.2705312 53.0130008 46.2705312 53.0130008 39.4750063 51.2791202 39.4750063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9871032,40.8187937 L57.3005857,40.8187937 L57.3005857,44.7934895 L65.9871032,44.7934895 L65.9871032,46.2704798 L57.4867926,46.2704798 C56.8218902,46.2704798 56.3558595,46.1073777 56.0404374,45.7611492 C55.7330591,45.4255318 55.5910079,44.8864218 55.5910079,44.018369 L55.5910079,41.0236556 C55.5910079,40.3496824 55.7527409,39.9319149 56.0808278,39.7392045 C56.39625,39.5653201 56.9367292,39.474955 57.6692343,39.474955 L65.9871032,39.474955 L65.9871032,40.8187937 Z",
    id: "Fill-16",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "78.8000032 40.8483849 70.2878835 40.8483849 70.2878835 42.1436182 75.6086429 42.1436182 75.6086429 43.4888261 70.2878835 43.4888261 70.2878835 44.8458431 78.8000032 44.8458431 78.8000032 46.2706339 68.6558348 46.2706339 68.6558348 39.475109 78.8000032 39.475109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8493902,40.8187937 L87.5429817,40.8187937 L87.5429817,44.7934895 L96.8493902,44.7934895 L96.8493902,46.2704798 L87.7276483,46.2704798 C87.0659977,46.2704798 86.5956884,46.1073777 86.2780413,45.7611492 C85.9742571,45.4255318 85.829981,44.8864218 85.829981,44.018369 L85.829981,41.0236556 C85.829981,40.3496824 85.9937677,39.9319149 86.3220259,39.7392045 C86.6360789,39.5653201 87.1758735,39.474955 87.9104323,39.474955 L96.8493902,39.474955 L96.8493902,40.8187937 Z",
    id: "Fill-18",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "110.908764 40.8483849 101.775555 40.8483849 101.775555 42.1436182 107.719286 42.1436182 107.719286 43.4888261 101.775555 43.4888261 101.775555 44.8458431 110.908764 44.8458431 110.908764 46.2706339 100.143507 46.2706339 100.143507 39.475109 110.908764 39.475109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "125.220184 46.2705654 122.550135 46.2705654 115.619918 40.8996602 115.619918 46.2705654 113.886038 46.2705654 113.886038 39.4750406 116.423962 39.4750406 123.488186 44.9470931 123.488186 39.4750406 125.220184 39.4750406"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "140.892079 40.8996945 135.262401 40.8996945 135.262401 46.2705996 133.528692 46.2705996 133.528692 40.8996945 127.872657 40.8996945 127.872657 39.4750748 140.892079 39.4750748"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "154.297127 40.8483849 145.163919 40.8483849 145.163919 42.1436182 151.105596 42.1436182 151.105596 43.4888261 145.163919 43.4888261 145.163919 44.8458431 154.297127 44.8458431 154.297127 46.2706339 143.531699 46.2706339 143.531699 39.475109 154.297127 39.475109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.004773,42.1760332 L166.795512,42.1760332 L166.795512,40.9319726 L159.004773,40.9319726 L159.004773,42.1760332 Z M168.284996,43.3269904 C168.029646,43.1221285 167.714224,43.0197832 166.795683,42.8782454 C168.060453,42.6424062 168.406339,42.3162018 168.406339,41.3903017 C168.406339,39.8713806 167.937227,39.4750063 166.164839,39.4750063 L157.275685,39.4750063 L157.275685,46.2705312 L159.008367,46.2705312 L159.008367,43.5494802 L166.795683,43.5494802 L166.795683,46.2705312 L168.508171,46.2705312 L168.508171,44.3242584 C168.508171,43.682803 168.458196,43.458944 168.284996,43.3269904 L168.284996,43.3269904 Z",
    id: "Fill-23",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSsc);
export default __webpack_public_path__ + "static/media/logo-ssc.3b4558a322d6d003fa8fc6741107b843.svg";
export { ForwardRef as ReactComponent };